import React from 'react';
import classnames from 'classnames';
import getRenderable from '../../../lib/getRenderable';
import { l_times } from '../../../icons';
import Icon from '../Icon';
import { StatusProps } from './types';
import { COLORS, THEMES } from './constants';
import classes from './index.module.scss';

/**
 * @deprecated Please use Alert from @fiverr-private/feedback instead.
 */
const Status = ({
    children,
    handleDismiss,
    className: customClassName,
    color,
    kind = 'material',
    theme = kind
}: StatusProps) => {
    const isDismissHandlerValid = typeof handleDismiss === 'function';
    const className = classnames(
        classes.status,
        customClassName,
        classes[`theme-${theme}`],
        {
            [classes[`color-${color}`]]: color,
            'box-shadow-z4': theme === 'material'
        }
    );

    return (
        <span className={className}>
            { getRenderable(children) }
            { isDismissHandlerValid && (
                <Icon size={10}
                    onClick={handleDismiss}
                    className={classes.dismiss}>
                    {l_times}
                </Icon>
            )}
        </span>
    );
};

Status.displayName = 'Status';

Object.assign(Status, {
    COLORS,
    KINDS: THEMES,
    THEMES
});

export default Status;
